module.exports = __webpack_public_path__ + "img/Ballons.afb742e.png";